<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.726"
    height="19.129"
    viewBox="0 0 19.726 19.129"
  >
    <path
      id="Union_29"
      data-name="Union 29"
      d="M7549.795,2882.125v-5.556h-5.728a2.006,2.006,0,1,1,0-4.009h5.728v-5.555a2.068,2.068,0,0,1,4.134,0v5.555h5.728a2.005,2.005,0,1,1,0,4.009h-5.728v5.556a2.068,2.068,0,0,1-4.134,0Z"
      transform="translate(-7541.999 -2865)"
      opacity="0.26"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
